import {HgPartnerService} from "./service/api/hg-partner.service";
import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {HgGdvPartnerObjectComponent} from "./component/object-components/hg-gdv-partner-object-component/hg-gdv-partner-object.component";
import {HgImportObjectComponent} from "./component/object-components/hg-import-object-component/hg-import-object.component";

export const HG_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['hg.HgPartner', {route: '/hg/hgPartners', service: HgPartnerService, objectComponent: [{component: HgGdvPartnerObjectComponent}]}],
            ['hg.HgPartnerPartner', {route: '/hg/hgPartnerPartners'}],
            ['hg.HgExportSatzart', {route: '/hg/hgExportSatzarts'}],
            ['hg.HgPartnerFlowOverride', {route: '/hg/hgPartnerFlowOverrides'}],
            ['hg.HgImport', {route: '/hg/hgImports', objectComponent: [{component: HgImportObjectComponent}]}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
